import React from 'react';

const EVENT = 'mousedown';

export const useClickAwayModal = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const modalRef = React.useRef<HTMLDivElement>(null);
  const callerRef = React.useRef<HTMLDivElement>(null);

  const handleEvent = React.useCallback(
    (event: MouseEvent | TouchEvent) => {
      const node = event.target as Node;

      if (callerRef && callerRef.current) {
        if (callerRef.current.contains(node)) {
          if (!modalRef || !modalRef.current) setIsOpen(true);
          else setIsOpen(false);

          return;
        }
      }

      if (modalRef && modalRef.current) {
        if (!modalRef.current.contains(node)) {
          setIsOpen(false);
          return;
        }
      }
    },
    [modalRef, callerRef]
  );

  React.useEffect(() => {
    document.addEventListener(EVENT, handleEvent);

    return () => {
      document.removeEventListener(EVENT, handleEvent);
    };
  }, [modalRef, handleEvent]);

  return { modalRef, callerRef, isOpen, setIsOpen } as const;
};
